import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Keys } from "@/components/site/Keys";
import { About } from "@/components/site/About";
import { ServicesIndex } from "@/components/site/ServicesIndex";
import { Rogaland } from "@/components/site/Rogaland";
import { EcuSection } from "@/components/site/EcuSection";
import { Chiptuning } from "@/components/site/Chiptuning";
import { Process } from "@/components/site/Process";
import { Inquiry } from "@/components/site/Inquiry";
import { Footer } from "@/components/site/Footer";
import { useLenis } from "@/components/site/smooth";
import { WhatsAppFab } from "@/components/site/WhatsApp";

export default function Home() {
  useLenis();
  return (
    <div className="grain" data-testid="home-page">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <ServicesIndex />
        <Chiptuning />
        <EcuSection />
        <Keys />
        <About />
        <Rogaland />
        <Process />
        <Inquiry />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
